import React, { useEffect, useState } from "react";
import CommonTable from "../../based/CommonTable";
import { INITPAGING, NOTIFY } from "../../based/Constants";
import { ConfirmDialog } from "../../based/Dialog";
import Loading from "../../based/Loading";
import { Notify } from "../../based/Notify";
import EmbroideryServices from "../../based/services/EmbroideryServices";
import styled from "styled-components";

function ThreadColorTab(props) {
    const [isBusy, setIsBusy] = useState(false);
    const [datas, setDatas] = useState([]);
    const [paging, setPaging] = useState({ ...INITPAGING });

    useEffect(() => {
        _getData({ ...INITPAGING });
    }, []);

    async function _getData(newPaging) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.GetThreadColors(newPaging);
        if (!err && data) {
            setDatas(data.listObjects);
            setPaging(data.paging);
        } else {
            setDatas([]);
            setPaging({ ...INITPAGING });
        }
        setIsBusy(false);
    }

    function _handleAddItem() {
        setDatas([{ id: 0, code: "", name: "", hexColor: "FFFFFF", isActive: true }, ...datas]);
    }

    function _isDisable(idx) {
        let item = datas[idx];
        if (!item.code || !item.name || !item.hexColor) return true;
        return false;
    }

    async function _handleCreateOrUpdate(idx) {
        setIsBusy(true);
        let [err, data] = await EmbroideryServices.CreateUpdateThreadColor({ ...datas[idx] });
        setIsBusy(false);
        if (!err && data) {
            Notify(NOTIFY.SUCCESS, NOTIFY.SUCCESS, "Lưu thành công");
            _getData(paging);
        } else {
            Notify(NOTIFY.ERROR, NOTIFY.ERROR, "Lưu thất bại");
        }
    }

    function _handleDelete(id, idx) {
        if (id > 0) {
            ConfirmDialog("Xác nhận xóa?", "Xin vui lòng xác nhận để xóa màu chỉ này", () => {
                return new Promise(async (resolve, reject) => {
                    let [err, data] = await EmbroideryServices.DeleteThreadColor(id);
                    if (!err && data) {
                        resolve({ title: "Thành công", msg: "Xóa thành công." });
                        _getData(paging);
                    } else {
                        Notify(NOTIFY.WARNING, "Có lỗi", "Có lỗi xảy ra trong quá trình xóa.");
                    }
                });
            });
        } else {
            let newData = [...datas];
            newData.splice(idx, 1);
            setDatas(newData);
        }
    }

    function _renderHeader() {
        return (
            <thead>
                <tr className='text-center'>
                    <th>Mã màu wilcom</th>
                    <th>Tên màu</th>
                    <th>Mã màu (hex)</th>
                    <th>Hành động</th>
                </tr>
            </thead>
        );
    }

    function _renderBody() {
        return (
            <tbody>
                {datas && datas.length > 0 ? (
                    datas.map((item, idx) => {
                        let isEditing = item.id <= 0 || item.isUpdate;
                        return (
                            <tr key={idx}>
                                <td style={{ width: 200 }}>
                                    {isEditing ? (
                                        <input
                                            className='input-in-table'
                                            type='text'
                                            placeholder='Mã màu wilcom'
                                            value={item.code}
                                            onChange={(e) => {
                                                let dt = [...datas];
                                                dt[idx].code = e.target.value;
                                                setDatas(dt);
                                            }}
                                        />
                                    ) : (
                                        item.code
                                    )}
                                </td>
                                <td style={{ width: 200 }}>
                                    {isEditing ? (
                                        <input
                                            className='input-in-table'
                                            type='text'
                                            placeholder='Tên màu'
                                            value={item.name}
                                            onChange={(e) => {
                                                let dt = [...datas];
                                                dt[idx].name = e.target.value;
                                                setDatas(dt);
                                            }}
                                        />
                                    ) : (
                                        item.name
                                    )}
                                </td>
                                <td style={{ width: 200, textAlign: "center" }}>
                                    {isEditing ? (
                                        <div className='d-flex align-items-center'>
                                            <input
                                                className='mr-2'
                                                type='text'
                                                placeholder='FFFFFF'
                                                value={item.hexColor}
                                                onChange={(e) => {
                                                    let dt = [...datas];
                                                    dt[idx].hexColor = e.target.value;
                                                    setDatas(dt);
                                                }}
                                            />
                                            <input
                                                type='color'
                                                value={`#${item.hexColor}`}
                                                onChange={(e) => {
                                                    let dt = [...datas];
                                                    dt[idx].hexColor = e.target.value.replace("#", "");
                                                    setDatas(dt);
                                                }}
                                            />
                                        </div>
                                    ) : (
                                        <span className='d-flex align-items-center justify-content-center'>
                                            {item.hexColor}
                                            <div style={{ background: `#${item.hexColor}`, width: 24, height: 24, marginLeft: 10, border: "1px solid #ccc" }}></div>
                                        </span>
                                    )}
                                </td>
                                <td style={{ width: 150, textAlign: "center" }}>
                                    {isEditing ? (
                                        <button className={`btn btn-custom m-1 ${_isDisable(idx) ? "disabled" : ""}`} onClick={() => !_isDisable(idx) && _handleCreateOrUpdate(idx)}>
                                            Lưu
                                        </button>
                                    ) : (
                                        <button
                                            className='btn btn-custom m-1'
                                            onClick={() => {
                                                let dt = [...datas];
                                                dt[idx].isUpdate = true;
                                                setDatas(dt);
                                            }}
                                        >
                                            Sửa
                                        </button>
                                    )}
                                    <button className='btn btn-danger m-1' onClick={() => _handleDelete(item.id, idx)}>
                                        Xóa
                                    </button>
                                </td>
                            </tr>
                        );
                    })
                ) : (
                    <tr>
                        <td colSpan={4} className='text-center'>
                            Không có dữ liệu
                        </td>
                    </tr>
                )}
                <tr>
                    <td colSpan={4}>
                        <div className='add-item' style={{ color: "#64C5B1", fontSize: 16, fontWeight: 600, cursor: "pointer" }} onClick={_handleAddItem}>
                            Thêm +
                        </div>
                    </td>
                </tr>
            </tbody>
        );
    }

    return (
        <Wrapper>
            <Loading show={isBusy} msg='Đang tải dữ liệu...' />
            <CommonTable data={datas} paging={paging} hideSearch hideSearchBasicButton renderHeader={_renderHeader} renderBody={_renderBody} onFilter={_getData} />
        </Wrapper>
    );
}

const Wrapper = styled.div`
    .input-in-table {
        border: none;
        outline: none;
        width: 100%;
        height: 40px;
        padding: 0;
    }
`;

export default ThreadColorTab;
